import { inject, Injectable } from '@angular/core';
import { CommonHttpService } from '../shard/common-http.service';
import { ToasterService } from '../ui-services.ts/toaster.service';
import { Observable } from 'rxjs';
import { IResponse } from '../../models/IResponse';
import { environment } from '../../../../environments/environment';
import { HttpPaths } from '../../models/Enums/http-paths';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {
  private _commonHttp = inject(CommonHttpService);

  constructor() { }
  addsubscriber(model: any): Observable<IResponse<any>> {
    return this._commonHttp.CommonPostRequests(model,environment.baseUrl + HttpPaths.ADD_SUBSCRIBER,{});
  }
}
